// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"459":"32033f4c","545":"07257de1","956":"0e2a6016"}[chunkId] + ".css";
};